import { SERVER_URL } from '../constants.js';

export const login = (credentials) => {
  return fetch(`${SERVER_URL}login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  }).then(async (response) => {
    // console.log(response)
    if (!response.ok) {
      if (response.status === 429) {
        // Rate limit exceeded
        let errorMessage = 'Too many requests. Please try again later.';
        try {
          const errorData = await response.json();
          if (errorData.error) {
            errorMessage = errorData.error;
          }
        } catch (e) {
          // If response is not JSON, use default message
        }
        const error = new Error(errorMessage);
        error.isRateLimit = true; // Flag to identify rate limit errors
        throw error;
      }
      const error = await response.text();
      throw new Error(error || 'Login failed');
    }
    
    const jwtToken = response.headers.get('Authorization');
    const data = await response.json();
    // console.log(data)
    return { 
      jwtToken, 
      role: data.role, 
      id: data.id, 
      activationStatus: data.activationStatus 
    };
  });
};